import React from 'react'
import T from 'prop-types'
import { Stack, Typography } from '@mui/material'

export default function SessionsOption({ label, value }) {
  return (
    <Stack alignItems="center">
      <Typography color="textSecondary" variant="body2">
        <strong>{label}</strong>
      </Typography>
      <Typography color="textPrimary" variant="body2">
        <strong>{value}</strong>
      </Typography>
    </Stack>
  )
}

SessionsOption.propTypes = {
  label: T.string.isRequired,
  value: T.string.isRequired,
}
